import styled from "styled-components";
import { Link } from "react-router-dom";

export const CreateDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  position: absolute;
  background: ${(props) => props.theme.body};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 16px;
  width: 230px;
  top: 50px;
  z-index: 2;
  transition: 0.2s;
  overflow: hidden;
`;

export const CreateDropdownButton = styled(Link)`
  border: none;
  outline: none;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  background: transparent;
  transition: 0.2s;
  line-height: 126.2%;
  color: ${(props) => props.theme.textColor};
  padding: 10px;
  margin: 5px 0;
  cursor: pointer;
  & div {
    display: flex;
    align-items: center;
  }
  &:hover {
    transition: 0.2s;
    background: ${(props) => props.theme.hover};
  }
  & svg {
    & path {
      fill: ${(props) => props.theme.textColor};
    }
  }
  & svg:nth-child(2) {
    max-width: 7px;
  }
`;
